import React from 'react';
import { useLocation } from 'react-router-dom';
import config from '@plone/volto/registry';
import { Grid } from 'semantic-ui-react';
import { default as RenderBlocks } from '@plone/volto/components/theme/View/RenderBlocks';

import { COLUMNSBLOCK } from '@eeacms/volto-columns-block/constants';
import cx from 'classnames';
import { getColumns } from '@eeacms/volto-columns-block/ColumnsBlock/utils';
import { getStyle } from '@eeacms/volto-columns-block/Styles';
import { useInView } from 'react-intersection-observer';

const ColumnsBlockView = (props) => {
  const location = useLocation();
  const { gridSizes } = config.blocks.blocksConfig[COLUMNSBLOCK];
  const { data = {}, gridSize = 12, gridCols = [] } = props.data;
  const metadata = props.metadata || props.properties;
  const columnList = getColumns(data);

  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0.2,
    triggerOnce: true,
  });

  return (
    <div
      id={props.id}
      className={cx(
        'columns-view',
        inView ? 'border animated-border' : 'border',
      )}
      ref={ref}
    >
      <Grid
        columns={gridSize}
        className={
          props.data.reverseWrap ? 'column-grid reverse-wrap' : 'column-grid'
        }
      >
        {columnList.map(([id, column], index) => {
          return (
            <Grid.Column
              key={id}
              {...(gridSizes[gridCols[index]] || gridCols[index])}
              className={cx(
                'column-blocks-wrapper',
                column.settings?.column_class,
              )}
              {...getStyle(column.settings || {})}
            >
              <RenderBlocks
                {...props}
                location={location}
                metadata={metadata}
                content={column}
              />
            </Grid.Column>
          );
        })}
      </Grid>
    </div>
  );
};

export default ColumnsBlockView;
